import React, { memo, useMemo } from "react";
import { v4 } from "uuid";
import classNames from "classnames";
import "./TableInfoRow.scss";

import UniversalCheckbox from "components/uiComponents/UniversalCheckbox";
import TableInfoCell from "components/uiComponents/TableInfoCell";

import { numberWithCommas, toArray } from "utils/helpers";
import { changeCheckbox } from "../../../store/actions/table";
import { useDispatch, useSelector } from "react-redux";

const TableInfoRow =
  ({
    lines,
    lineElements,
    id,
    checked,
    onCheckChange,
    unitsArr,
    table,
    rowIndex
  }) => {

    const dispatch = useDispatch();

    const { selectedOptions } = useSelector(state => state.table);

    const handleChange = (id, isChecked, cellIndex) => {
      dispatch(changeCheckbox({checked: isChecked, lineElements, id, missingProperties: table.missingProperties[rowIndex][cellIndex]}));
    }

    const restCells = useMemo(() => {
      return lines.map((el, index) => {
          let elUpd = el;
          let isChecked = false;
        if (typeof el === 'number') {
            if (el % 1 !== 0) {
              elUpd = numberWithCommas(el.toFixed(2));
            }
          }

          const id = `${lines[0]}/${table.header[index]}/${el}-${index}`;

          selectedOptions.forEach((el) => {
            if(el.id === id) {
              isChecked = el.checked;
            }
          })

          return (
            <TableInfoCell key={id}>
              <div className="table-info-row__cell_content">
                  <UniversalCheckbox
                    name="table-cell"
                    onChange={() => handleChange(id, isChecked, index)}
                    checked={isChecked}
                  />
                <span style={String(elUpd).includes("missing") ? {color: "#FF3D00", fontWeight: "600"} : {}}>
                  {elUpd}&nbsp;
                </span>

                {!!el &&
                  <span>
                    {unitsArr?.[index]?.unit}
                  </span>
                }

                {!!el && unitsArr?.[index]?.subUnit &&
                  <span className="table-info-row__cell_sup">{unitsArr?.[index]?.subUnit}</span>
                }
              </div>
            </TableInfoCell>
          )
      });
    }, [lines, unitsArr, selectedOptions]);

    return (
      <div
        className={classNames({
          "table-info-row": true,
          "table-info-row--checked": !!checked,
        })}
      >
        {restCells}
      </div>
    );
  }

export default TableInfoRow;
